import { render } from "./TheTopHeader.vue?vue&type=template&id=7ded4afd&scoped=true"
import script from "./TheTopHeader.vue?vue&type=script&lang=js"
export * from "./TheTopHeader.vue?vue&type=script&lang=js"

import "./TheTopHeader.vue?vue&type=style&index=0&id=7ded4afd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ded4afd"]])

export default __exports__